import FormFieldChooseGroup from "../../components/FormFieldChooseGroup/FormFieldChooseGroup";
import FormFieldCreateUsername from "../../components/FormFieldCreateUsername/FormFieldCreateUsername";
import FormFieldHidden from "../../components/FormFieldHidden/FormFieldHidden";
import FormFieldInputText from "../../components/FormFieldInputText/FormFieldInputText";
import FormFieldMultiSelect from "../../components/FormFieldMultiSelect/FormFieldMultiSelect";
import FormFieldSelect from "../../components/FormFieldSelect/FormFieldSelect";
import FormFieldSelectCity from "../../components/FormFieldSelectCity/FormFieldSelectCity";
import FormFieldSelectPLZ from "../../components/FormFieldSelectPLZ/FormFieldSelectPLZ";
import FormFieldSelectStreet from "../../components/FormFieldSelectStreet/FormFieldSelectStreet";

export enum CustomerDataFields {
    FORMOFADDRESS = "anrede",
    TITLE = "titel",
    PRENAME = "vorname",
    SURNAME = "nachname",
    PHONENUMBER = "telefon",
    MAIL = "email",
    ISBILLINGMAIL = "istRechnungsEmail",
    LOGIN = "loginName",
    COMPANYNAME = "firmenname",
    TRADE = "branche",
    PLZ = "plz",
    CITY = "ort",
    STREET = "strasse",
    STREETNUMBER = "nr",
    BILLINGMAIL = "rechnungsEmail",
    HOMEPAGE = "web",
    POSITION = "position",
    SOLICITOR = "fachanwaltschaft",
    INTERESTS = "interessen",
    MEMBERSHIPS = "mitgliedschaften",
    PAYTYP = "payType",
    IBAN = "iban",
    CONTACTNO = "contactNo",
    TRACKINGCONSENT = "trackingConsent",
}

export enum CustomerDataOptionsFormOfAddress {
    WOMAN = "frau",
    MAN = "herr"
}

export enum CustomerDataOptionsPayTyp {
    DEBIT = "lastschrift",
    BILL = "rechnung"
}

export type CustomerData = {
    [key in CustomerDataFields]?: string | string[];
};

export interface CustomerDataFieldConfiguration {
    required: boolean;
    validation?: string;
    maxLength?: number;
    ref?: FormFieldChooseGroup 
        | FormFieldInputText 
        | FormFieldSelect 
        | FormFieldMultiSelect 
        | FormFieldCreateUsername
        | FormFieldSelectCity
        | FormFieldSelectPLZ
        | FormFieldSelectStreet
        | FormFieldHidden;
}

export type CustomerDataFieldConfigurations = {
    [key in CustomerDataFields]: CustomerDataFieldConfiguration;
}
